import LambdaInvoke from '@/library/utils/LambdaInvoke';
import { LAMBDA_GET_MENSAJES, LAMBDA_MARCAR_COMO_LEIDO, AWS_ENV } from '@/config';

export async function apiGetMensajes(contribuyente, username, pagination={}, opts={}){
	try{
		
		const {
			itemsPerPage, page, sortBy=[], sortDesc=[]
		} = pagination;
		const paginacion = {
			itemsPerPage, page, sortBy:sortBy.pop(), sortDesc:sortDesc.pop()
		}
		const payload = {contribuyente, username, paginacion, opts, env:AWS_ENV};

		let body = await LambdaInvoke(LAMBDA_GET_MENSAJES, payload);
		return body;
	}catch(err){
		console.error(err)
		throw err;
	}
}

export async function apiMarcarComoLeido( 
	grupoId, usuario, contribuyente, hash,
	respuestas
){
	try{
		const payload = {
			grupoId, usuario, contribuyente, hash, respuestas
		}

		if( AWS_ENV !== 'prod' ) payload.env = AWS_ENV;
		let body = await LambdaInvoke(LAMBDA_MARCAR_COMO_LEIDO, payload);
		return body;
	}catch(err){
		console.error(err)
		throw err;
	}
}